import { isTerminalStatus } from './FileUtils';
//new asset creation object with default props.
export class Asset {
	constructor(id, name = '', isAddedBySystem = false) {
		this.id = id;
		this.name = name;
		this.isAssetNameUnqiueOnUI = true;
		this.isAssetNameUniqueInBackEnd = true;
		this.existingAssetUUID = '';
		this.sourceFiles = [];
		this.tags = [];
		this.product = {};
		this.createJira = false;
		this.barcode = '';
		this.archived = false;
		/*
		This field keeps track of how an asset is added to UI. 
		when added automatically by system below field is set to true (e.g.when landed on manual entry page, one asset is added automatically on UI.).
		when added by user action below field is set as false.
		*/
		this.isAddedBySystem = isAddedBySystem;
	}
}

export const assetHasPublishedArtifacts = (asset) => {
	// Check to see if an artifact has terminal statuses of a primary source file.
	const primarySrcFile = asset?.sourceFiles?.filter((srcFile) => srcFile.isPrimary);
	const hasPublishedArtifact = primarySrcFile[0]?.artifacts?.some((artifact) =>
		isTerminalStatus(artifact.status.toLowerCase()),
	);
	return hasPublishedArtifact;
};

export const getPrimarySrcFileUrl = (asset) => {
	let primarySrcFileImgUrl = '';
	asset.sourceFiles.forEach((src) => {
		if (src.isPrimary) {
			primarySrcFileImgUrl = src.imageUrl;
		}
	});
	return primarySrcFileImgUrl;
};
